// extracted by mini-css-extract-plugin
export default {"header":"Header_header__IMlHQ","logo":"Header_logo__uA0ZJ"};